import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'
import Img from 'gatsby-image'

import LinkedInLogo from '../../../assets/svg/linkedin-logo-square.svg'

const StyledMember = styled.div`
  border-radius: 8px;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;

  :after {
    background: #ffffff;
    border-radius: 8px;
    content: '';
    height: 100%;
    left: 0;
    opacity: ${({ isActive }) => (isActive ? '0' : '.66')};
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: opacity 0.4s ease;
    width: 100%;
  }
`

const StyledImage = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  transition: opacity 0.4s ease, transform 0.4s ease;
  width: 100%;

  div {
    height: 100%;
    width: 100%;
  }
`

const StyledBio = styled.div`
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.01) 8%,
    rgba(0, 0, 0, 0.05) 16%,
    rgba(0, 0, 0, 0.11) 22%,
    rgba(0, 0, 0, 0.18) 59%,
    rgba(0, 0, 0, 0.26) 71%,
    rgba(0, 0, 0, 0.35) 79%,
    rgba(0, 0, 0, 0.45) 84%,
    rgba(0, 0, 0, 0.55) 92%
  );
  align-items: flex-end;
  border-radius: 8px;
  bottom: 0;
  display: flex;
  height: 128px;
  opacity: ${({ isActive }) => (isActive ? '1' : '0')};
  padding: 24px;
  position: absolute;
  transition: opacity 0.4s ease;
  width: 100%;

  h6,
  p {
    color: #fff;
    font-size: 0.875em;
    font-weight: 700;
    line-height: 1.71;
  }

  p {
    font-weight: 500 !important;
  }
`

const StyledBioText = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 80%;
`

const StyledBioIcon = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: flex-end;
  width: 20%;
`

const StyledSVG = styled(SVG)`
  svg {
    height: 24px;
    width: 24px;

    path {
      fill: #fff;
    }
  }
`
const StyledPersonIMG = styled.div`
  background-image: url(${({ url }) => url});
  background-position: center;
  background-size: cover;
`
const RenderImage = data => {
  if (data.hasOwnProperty('sys')) {
    return <StyledPersonIMG url={data.fields.file.url} />
  } else {
    return <Img fluid={data.fluid} />
  }
}

const Member = ({ data, isActive, onClick }) => {
  return (
    <StyledMember onClick={() => onClick()} isActive={isActive}>
      <StyledImage>{RenderImage(data.picture)}</StyledImage>
      <StyledBio isActive={isActive}>
        <StyledBioText>
          <h6>{data.name}</h6>
          <p>{data.role}</p>
        </StyledBioText>
        <StyledBioIcon>
          <a href={data.linkedIn} target="_blank" rel="noopener noreferrer">
            <StyledSVG src={LinkedInLogo} />
          </a>
        </StyledBioIcon>
      </StyledBio>
    </StyledMember>
  )
}

Member.propTypes = {
  data: PropTypes.object.isRequired,
}
export default Member
